import { Log } from "../../util/Log";
var log = Log.log;
export class Alt1GLFrameStream {
    constructor(stream) {
        this.stream = stream;
        Alt1GLFrameStream._streams.push(this);
        log().log(`Alt1GLFrameStream created. ${Alt1GLFrameStream._streams.length} active streams`, "Alt1GL");
    }
    endLifetime() {
        this.stream.close();
        Alt1GLFrameStream._streams = Alt1GLFrameStream._streams.filter(s => s != this);
        log().log(`Alt1GLFrameStream closed. ${Alt1GLFrameStream._streams.length} active streams`, "Alt1GL");
    }
}
Alt1GLFrameStream._streams = [];
